import React from "react";

export function BoardRemoteCursors({ cursors, selfUserId }) {
  const list = Object.values(cursors || {}).filter((c) => c.user_id && c.user_id !== selfUserId);
  if (!list.length) return null;

  return (
    <>
      {list.map((cursor) => (
        <div
          key={cursor.user_id}
          className="pointer-events-none absolute z-[9999]"
          style={{ left: cursor.x, top: cursor.y, transform: "translate(-2px, -2px)" }}
        >
          <svg width="20" height="24" viewBox="0 0 20 24" fill="none" aria-hidden>
            <path
              d="M3 2L16 14H9L11 22L3 2Z"
              fill={cursor.color || "#001EFF"}
              stroke="white"
              strokeWidth="1.5"
            />
          </svg>
          <span
            className="ml-3 -mt-1 inline-block max-w-[140px] truncate rounded px-1.5 py-0.5 text-[10px] font-medium text-white shadow-sm"
            style={{ backgroundColor: cursor.color || "#001EFF" }}
          >
            {cursor.name || "User"}
          </span>
        </div>
      ))}
    </>
  );
}
